import { useMutation } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { CurriculumGrade } from "./useGetCurriculumManagementQuery";

export interface UpdateCurriculumManagementRequest {
  schoolId: string;
  data: {
    data: {
      classes: Array<{
        class_id: string;
        curriculum_id: string;
        modules: Array<{
          module_id: string;
          sub_modules: Array<{
            sub_module_id: string;
            tlm_topics: Array<{
              tlmMasterId: string;
            }>;
          }>;
        }>;
      }>;
    };
  };
}

export interface UpdateCurriculumManagementResponse {
  success: boolean;
  message: string;
  data?: CurriculumGrade[];
}

interface UseUpdateCurriculumManagementMutationProps {
  onSuccess?: (data: UpdateCurriculumManagementResponse) => void;
  onError?: (error: any) => void;
}

const updateCurriculumManagement = async (
  data: UpdateCurriculumManagementRequest
): Promise<UpdateCurriculumManagementResponse> => {
  const { schoolId, data: curriculumData } = data;
  const response = await axiosAuth.put<UpdateCurriculumManagementResponse>(
    `/v1/school/crm/curriculum-management/${schoolId}/`,
    curriculumData
  );
  return response.data;
};

export const useUpdateCurriculumManagementMutation = ({
  onSuccess,
  onError,
}: UseUpdateCurriculumManagementMutationProps = {}) =>
  useMutation<UpdateCurriculumManagementResponse, Error, UpdateCurriculumManagementRequest>({
    mutationFn: updateCurriculumManagement,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
